import { createSelector } from 'reselect';
import { Army, ArmySource } from '@Models';
import { getArmies } from '@Selectors/builder/myBuilder/selector';
import { ArmyGameView } from './view/ArmyGameView';
import { ArmyView } from '@Selectors/builder/myBuilder/builder/new/view/ArmyView';
import { getUserPreference } from '@Selectors/profile/selector/getUserPreference';

export const uniqueSource = (
  value: ArmyGameView,
  index: number,
  self: Array<ArmyGameView>,
): boolean => {
  return (
    self.findIndex(
      (i) => i.source === value.source && i.versionId == value.versionId,
    ) === index
  );
};

const buildArmyGameViews = (armies: Army[]): ArmyGameView[] => {
  return armies
    .map(
      (army) =>
        new ArmyGameView({
          label: `activerecord.attributes.ninth_age_army.source.${ArmySource[army.source]}`,
          versionId: army.versionId,
          source: army.source,
          options: new Array<ArmyView>(),
        }),
    )
    .filter(uniqueSource)
    .map((armySource) => {
      armySource.options = armies
        .filter(
          (army) =>
            army.source === armySource.source &&
            army.versionId === armySource.versionId,
        )
        .map(
          (army) =>
            new ArmyView({
              id: army.id,
              name:
                army.nameWithSubVersion + (army.isLatest ? ' (latest)' : ''),
              versionId: army.versionId,
            }),
        );

      return armySource;
    });
};

export const ArmyGamePresenter = createSelector(
  [getArmies, getUserPreference],
  (armies, userPreference): Array<ArmyGameView> => {
    const availableArmies = armies.filter(
      (item) => !userPreference.useLatestVersion || item.isLatest,
    );

    return buildArmyGameViews(availableArmies);
  },
);
